// Scroll-pinned horizontal gallery for ScrollingGalleryBlockElement.
// While the outer section occupies 400vh of vertical space, the inner sticky
// wrapper stays pinned and its track translates left proportional to scroll
// progress.
export default function initScrollingGallery() {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-scrolling-gallery]').forEach((section) => {
        const track = section.querySelector('[data-scrolling-gallery-track]');
        if (!track) return;

        let ticking = false;

        const update = () => {
            ticking = false;
            const rect = section.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const scrollable = Math.max(1, rect.height - vh);
            const raw = Math.min(1, Math.max(0, -rect.top / scrollable));

            const travel = track.scrollWidth - window.innerWidth;
            const x = -raw * travel;
            track.style.transform = `translate3d(${x}px, 0, 0)`;
        };

        const onScroll = () => {
            if (!ticking) { ticking = true; requestAnimationFrame(update); }
        };

        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
    });
}
